module.exports = __webpack_public_path__ + "static/media/slalom-logo-theme-default.76ff6040.svg";